import Input from "../../Components/Base/Input";
import Button from "../../Components/Base/Button";
import React, { FormEvent, useCallback, useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Toast } from "../../Utils";

import { TransactionSetPassword } from "../../Services/Transactions";
import { AuthContext, ProfileContext } from "../../Context";
import { Link } from "react-router-dom";

const SetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // ======================================================

  const { setToken } = useContext(AuthContext);
  const { setPersonalVerification } = useContext(ProfileContext);

  // ======================================================

  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");

  const [loading, setLoading] = useState<boolean>(false);

  // ======================================================

  const isValid = useCallback(() => {
    return password.length > 7 && password2.length > 7;
  }, [password, password2]);

  // ======================================================

  const handleSubmitForm = async (e: FormEvent) => {
    e.preventDefault();
    if (isValid()) {
      setLoading(true);
      TransactionSetPassword({ phoneNumber: location.state.phone, password })
        .then(({ data: res }) => {
          if (res.transaction_status) {
            localStorage.setItem("Token", res.data!.token);
            setToken(res.data!.token);
            setPersonalVerification(res.data!.personal_verification);
            Toast("success", res.message);
            navigate("/");
          } else {
            Toast("error", res.message);
          }
        })
        .finally(() => setLoading(false));
    } else Toast("error", "لطفا موبایل و رمز عبور خود را وارد کنید.");
  };

  // ======================================================

  return (
    <div
      className="container mt-sm-5 mb-5 bg-primary-soft rounded-3"
      style={{ background: "rgba(33, 99, 232, 0.1)" }}
    >
      <div className="row">
        <div className="col-md-10 col-lg-8 col-xl-6 mx-auto">
          <div className="p-3 my-5 p-sm-5 rounded">
            <h2 className="text-center">رمز عبور خود را مشخص کنید</h2>

            <form className="mt-4" onSubmit={handleSubmitForm}>
              <div className="mb-4">
                <Input
                  placeholder="رمز عبور خود را وارد کنید"
                  inputClass="text-center"
                  setValue={setPassword}
                  value={password}
                  type="password"
                  label="رمز عبور"
                  inputAttrs={{ autoFocus: true, dir: "ltr" }}
                />
                <br />
                <Input
                  placeholder="تکرار رمز عبور خود را وارد کنید"
                  inputClass="text-center"
                  setValue={setPassword2}
                  value={password2}
                  type="password"
                  label="تکرار رمز عبور"
                  inputAttrs={{ dir: "ltr" }}
                />
              </div>

              <div className="row align-items-center">
                <div className="col-12">
                  <Button
                    btnClass="btn-primary w-100"
                    isLoading={loading}
                    disabled={!isValid()}
                  >
                    <span>تایید</span>
                  </Button>
                </div>
                <hr className="mt-3" />
                <div className="col-12 d-flex justify-content-between align-items-center flex-column gap-2">
                  <Link
                    className="btn btn-white w-100 text-center justify-content-center text-black d-flex gap-2 align-items-center"
                    to="/login"
                  >
                    <i
                      className="fa fa-door-open text-black"
                      style={{ fontSize: 12 }}
                    />
                    ورود با رمز عبور
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
